import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export default api;

// ── Credits: one place to notice a spend and one place to explain a 402 ──
const METERED = ["/studio/", "/create/"];

api.interceptors.response.use(
  (res) => {
    const url = res.config?.url || "";
    if ((res.config?.method || "").toLowerCase() === "post" &&
        METERED.some((p) => url.includes(p))) {
      window.dispatchEvent(new Event("rammy-credits-changed"));
    }
    return res;
  },
  (err) => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 402 && detail?.error === "insufficient_credits") {
      window.dispatchEvent(new Event("rammy-credits-changed"));
      toast.error(detail.message || "You're out of credits.", {
        action: {
          label: "Top up",
          onClick: () =>
            window.dispatchEvent(new CustomEvent("rammy-navigate", { detail: { target: "credits" } })),
        },
      });
    }
    return Promise.reject(err);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
